
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class PatientGenderPercentage extends Vue {
  // Translated column headers
  headerTranslations: Record<string, string> = {
    Gender: "Geschlecht",
    PatientCount: "Patientenanzahl",
    PatientPercentage: "Patientenanteil"
  };

  get chartData(): any[] {
    return dataVisualizationModule.getChartData("patientCount");
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("patientCount");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
